/* eslint-disable no-restricted-syntax */
/* eslint-disable max-classes-per-file */
import React from 'react'
import Select from 'react-select'
import { FormItem, FormItemProps } from './FormItem'
import { IField, getRequiredError } from './FieldValidation'
import { Option } from './Options'
import { ErrorText } from './ErrorText'

export interface SelectFieldSlimProps<V> extends FormItemProps {
    id: string
    disabled?: boolean
    onChange: { (value: V): any },
    value: V,
    dataSource: Option<V>[]
    required?: boolean
    requiredMessage?: string
    block?: boolean
    position?: string
}

export interface SelectFieldSlimState {
    errorText?: string
}

export const selectSlimStyles = (block: boolean, error: boolean, position?: string) => ({
  container: (provided: any, state: any) => ({
    ...provided,
    maxWidth: block === false ? '12.8125rem' : '',
    top: '50%',
    transform: 'translateY(-50%)',
    width: '95%',
    margin: '0px auto',
  }),
  control: (provided: any, state: any) => ({
    ...provided,
    borderRadius: '0px',
    border: `1px solid ${error ? '#d60000' : '#cccccc'}`,
    backgroundColor: `${error && !state.isFocused ? '#fdf2f2' : '#ffffff'}`,
    boxShadow: 'none',
    padding: '0px 3px',
    '&:hover': {
      border: `1px solid ${error ? '#d60000' : '#cccccc'}`,
    },
    outline: state.isFocused ? '3px solid #9263DE' : '',
    outlineOffset: state.isFocused ? '2px' : '',
    minHeight: '31px',
    height: '31px',
  }),
  option: (provided: any, state: any) => ({
    ...provided,
    backgroundColor: '#ffffff',
    color: '#000000',
    '&:hover': {
      backgroundColor: '#c47ccf',
    },
    '&:active': {
      backgroundColor: '#893c94',
    },
  }),

  dropdownIndicator: (provided: any, state: any) => ({
    height: '25px',
    padding: '0px 8px',
  }),
  clearIndicator: (provided: any, state: any) => ({
    height: '25px',
    padding: '0px 8px',
  }),
  menu: (provided: any, state: any) => ({
    ...provided,
    zIndex: 200,
    ...(position && { position }),
  }),
  singleValue: (provided: any, state: any) => ({
    ...provided,

    fallbacks: ['-moz-calc(100% - 5rem)',
      '-webkit-calc(100% - 5rem)',
      '-o-calc(100% - 5rem)',
    ],
  }),
})

export class SelectFieldSlim<V> extends React.Component<SelectFieldSlimProps<V>, SelectFieldSlimState> implements IField {
  input: React.RefObject<any> = React.createRef()

  constructor(props?: SelectFieldSlimProps<V>, context?: any) {
    super(props, context)

    this.state = {
    }
  }

  componentDidUpdate(prevProps: SelectFieldSlimProps<V>) {
    const { value } = this.props
    const { errorText } = this.state
    if (value !== prevProps.value) {
      if (errorText) {
        this.validate(() => { })
      }
    }
  }

  getLabel() {
    const { label } = this.props
    return label
  }

  render() {
    const {
      dataSource, value, preview, id, block, position, onChange, disabled,
    } = this.props
    const { errorText } = this.state
    let val: Option<V> = null
    if (dataSource) {
      for (const data of dataSource) {
        if (data.value === value) {
          val = data
          break
        }
      }
    }

    if (preview) {
      return (
        <FormItem {...this.props} inputId={id} errorMessage={errorText}>
          <div className="form-value">{val && val.label}</div>
        </FormItem>
      )
    }

    return (
      <Select
        styles={selectSlimStyles(block, !!errorText, position)}
        id={id}
        ref={this.input}
        options={dataSource}
        value={val}
        isClearable
        onChange={(v: any) => onChange(v === null ? null : v)}
        isDisabled={disabled}
        menuPortalTarget={document.querySelector('body')}
      />
    )
  }

  focus() {
    if (this.input.current) {
      const selectElement = this.input.current as any
      if (selectElement && selectElement.focus) {
        selectElement.focus()
      }
    }
  }

  hasValue(): boolean {
    const { value, dataSource } = this.props
    let res = false
    if (dataSource) {
      for (const data of dataSource) {
        if (data.value === value) {
          res = true
          break
        }
      }
    }
    return res
  }

  getErrorText(): string {
    const { required } = this.props
    if (required === true) {
      if (!this.hasValue()) {
        return getRequiredError(this.props)
      }
    }
    return null
  }

  validate(callback: { (res: boolean): any }, focus?: boolean) {
    const errorText = this.getErrorText()
    this.setError(errorText, () => {
      const { errorMessage } = this.props
      if (errorMessage || errorText) {
        if (focus === true) {
          this.focus()
        }
      }

      callback && callback(!((this.props.errorMessage || errorText)))
    })
  }

  setError(errorText?: string, callback?: { (): any }) {
    this.setState({ errorText }, callback)
  }
}
